// Read VITE_* env at module load and validate. Crash early if anything's missing.

import type { FirebaseConfig } from "@goodbye/firebase";

function required(key: string): string {
  const v = import.meta.env[key];
  if (!v || typeof v !== "string") {
    throw new Error(
      `[env] Missing required env var ${key}. Did you copy .env.example to .env.local?`,
    );
  }
  return v;
}

function optional(key: string): string | undefined {
  const v = import.meta.env[key];
  return typeof v === "string" && v.length > 0 ? v : undefined;
}

export const env = {
  firebase: {
    apiKey: required("VITE_FIREBASE_API_KEY"),
    authDomain: required("VITE_FIREBASE_AUTH_DOMAIN"),
    projectId: required("VITE_FIREBASE_PROJECT_ID"),
    storageBucket: required("VITE_FIREBASE_STORAGE_BUCKET"),
    messagingSenderId: required("VITE_FIREBASE_MESSAGING_SENDER_ID"),
    appId: required("VITE_FIREBASE_APP_ID"),
  } satisfies FirebaseConfig,
  stadiaApiKey: required("VITE_STADIA_API_KEY"),
  // Push (FCM) — optional. If missing, push subscription is skipped silently
  // and the Countdown shows "· 通知不支援". Set in CF Pages env on prod.
  vapidKey: optional("VITE_FIREBASE_VAPID_KEY"),
  useEmulators: import.meta.env.VITE_USE_EMULATORS === "true",
  // Sentry DSN — optional. If missing, error reporting is a no-op and the
  // ErrorBoundary still works (just logs to console). Set in CF Pages env
  // on prod so 25 phones don't silently fail.
  sentryDsn: optional("VITE_SENTRY_DSN"),
  // Commit SHA stamped at build time so Sentry groups errors by release.
  // CF Pages sets CF_PAGES_COMMIT_SHA; we mirror it as VITE_RELEASE in the
  // build command. Falls back to "dev" locally.
  release: optional("VITE_RELEASE") ?? "dev",
} as const;
